import {
  takeEvery,
  call,
  put,
  select,
} from 'redux-saga/effects'
import axios from 'axios'

import { Types, loadPresentsSuccess, loadPresentsError } from '../ducks/presents'

function* fetchPresents() {
  try {
    const host = yield select(state => state.settings.host)
    const items = yield call(axios, {
      method: 'GET',
      url: `${host}presents/list`,
      headers: {
        'origin-local': 'http://joaoemaria.caseme.local',
      },
    })

    yield put(loadPresentsSuccess(items.data.list))
  } catch (err) {
    yield put(loadPresentsError(err))
  }
}

export default function* () {
  yield takeEvery(Types.LOAD_PRESENTS, fetchPresents)
}
